import { User } from '@api';
import { useTheme } from '@mui/material';
import { UserContext } from '@views/UserContext';
import { useContext } from 'react';

import { getGradient } from '../color-utils';


export function useGetUserWithColorById(userId: string): User | undefined {
    const { users } = useContext(UserContext);

    // this is used to append the avatar color to the user object
    const theme = useTheme();
    const colors = getGradient(theme.palette.primary.main, users.length)?.map(color => color.toHexString()) || [];

    const userIndex = users.findIndex(user => user.id === userId);

    return {
        ...users[userIndex],
        avatarColor: colors[userIndex]
    };
}
